import {DEFAULT_DARK_LAYER, DEFAULT_LIGHT_LAYER, MAP_LAYERS} from "@ui/leafletCustom/titleLayer/constants/layers";
import {UiTheme} from "@view/theme/types";

export const getInitialLayer = (theme: UiTheme) => {
    const searchParams = new URLSearchParams(window.location.search);
    const initialMapLayer = searchParams.get('mapLayer');
    if (initialMapLayer && initialMapLayer in MAP_LAYERS) {
        return initialMapLayer
    }
    if (theme === 'dark') {
        return DEFAULT_DARK_LAYER
    }
    return DEFAULT_LIGHT_LAYER

}